/*
const templateSelectors = [
  'body.index',
  'body.template-collection-2024'
];

const productHandles = [
  'alpha-t-test-booster',
  'build-burn-stack',
  'magnum-man-stack',
  'ultimate-build-burn-stack'
];

templateSelectors.forEach(templateSelector => {
  productHandles.forEach(handle => {
    const fullSelector = `${templateSelector} .product-card.${handle} product-form`;
    const target = document.querySelector(fullSelector);

    if (target) {
      const link = document.createElement('a');
      link.href = `/products/${handle}`;
      link.className = 'd-flex p-0 text-center ntrx-coming-soon-btn';

      link.innerHTML = `
        Back in Stock Soon.<br>
        Get Notified &rarr;
      `;

      target.prepend(link);
    }
  });
});
*/

/* With Amazon Buy Button - collections & home */

/*
const templateSelectors = [
  'body.index',
  'body.template-collection-2024'
];

const productHandles = [
  'alpha-t-test-booster',
  'build-burn-stack',
  'magnum-man-stack',
  'ultimate-build-burn-stack'
];

templateSelectors.forEach(templateSelector => {
  productHandles.forEach(handle => {
    const fullSelector = `${templateSelector} .product-card.${handle} product-form`;
    const target = document.querySelector(fullSelector);

    if (target) {
      // "Back in Stock Soon" link (prepend for all products)
      const link = document.createElement('a');
      link.href = `/products/${handle}`;
      link.className = 'd-flex p-0 text-center ntrx-coming-soon-btn';
      link.innerHTML = `Back in Stock Soon.<br>Get Notified &rarr;`;
      target.prepend(link);

      // Only add "Buy on Amazon" button for 'alpha-t-test-booster'
      if (handle === 'alpha-t-test-booster') {
        const amazonBtn = document.createElement('a');
        amazonBtn.href = 'https://www.amazon.com/Nutrex-Research-Testosterone-Supplement-Ashwagandha/dp/B0DP1KTN47?maas=maas_adg_F86621FD8A6999BB902BA5A0644526DF_afap_abs&ref_=aa_maas&tag=maas';
        amazonBtn.target = '_blank';
        amazonBtn.rel = 'noopener noreferrer';
        amazonBtn.className = 'nx-buy-amazon-btn mx-2 mx-md-3 mt-2 d-inline-block text-center';
        amazonBtn.textContent = 'Buy on Amazon';

        target.parentNode.insertBefore(amazonBtn, target.nextSibling);
      }
    }
  });
});

/* amazon on PDP */

/*
if (document.body.classList.contains('alpha-t-test-booster')) {
  const target = document.querySelector('.supp-facts-wrapper');

  if (target) {
    const amazonBtn = document.createElement('a');
    amazonBtn.href = 'https://www.amazon.com/Nutrex-Research-Testosterone-Supplement-Ashwagandha/dp/B0DP1KTN47?maas=maas_adg_F86621FD8A6999BB902BA5A0644526DF_afap_abs&ref_=aa_maas&tag=maas'; // Replace with actual Amazon link
    amazonBtn.target = '_blank';
    amazonBtn.rel = 'noopener noreferrer';
    amazonBtn.className = 'buy-amazon-pill w-100 text-center d-inline-block mb-3';
    amazonBtn.textContent = 'Buy on Amazon';

    target.parentNode.insertBefore(amazonBtn, target);
  }

  // Add styles
  const style = document.createElement('style');
  style.textContent = `
    .buy-amazon-pill {
      height: 40px;
      line-height: 40px;
      background-color: #ffa41c;
      color: #000;
      text-decoration: none;
      font-weight: 600;
      font-size: 16px;
      transition: background-color 0.2s ease-in-out;
    }
    .buy-amazon-pill:hover,
    .buy-amazon-pill:focus {
      background-color: #f26e2c;
      color: #000;
    }
  `;
  document.head.appendChild(style);
}

/*------- temp customizations above this ---------*/

const customSelectors = {};
class customJS {
  constructor() {
    this.parallaxCode();
    window.addEventListener("scroll", this.parallaxCode(), false);
    this.contactUsPage = document.querySelector("[data-contactUsPage]");
    if (this.contactUsPage) {
      this.checkEmail =
        this.contactUsPage.querySelectorAll("[data-checkEmail]");
      if (this.checkEmail)
        this.checkEmail.forEach((input) =>
          input.addEventListener("keyup", this.checkConfirmEmail.bind(this))
        );

      this.subjectField = this.contactUsPage.querySelector(
        "[data-subjectField]"
      );
      if (this.subjectField)
        this.subjectField.addEventListener(
          "keyup",
          this.checkSubjectFieldCount.bind(this)
        );
      this.messageField = this.contactUsPage.querySelector(
        "[data-messageField]"
      );
      if (this.messageField)
        this.messageField.addEventListener(
          "keyup",
          this.checkMessageFieldCount.bind(this)
        );
    }
  }

  parallaxCode() {
    var parallaxBigImage = document.querySelectorAll(".simple-parallax-effect");
    if(parallaxBigImage.length > 0) {
      parallaxBigImage.forEach(function(target) {
        // console.log(target)
        new simpleParallax(target, {
          overflow: true,
          orientation: "left",
          scale: 2,
          transition: "cubic-bezier(0,0,0,1)",
        });
      });
    }
  }

  checkConfirmEmail(event) {
    let emailField =
      this.contactUsPage.querySelector("[data-emailField]").value;
    let confirmEmail = this.contactUsPage.querySelector(
      "[data-confirmEmail]"
    ).value;
    if (emailField.length > 0 && confirmEmail.length > 0) {
      if (emailField != confirmEmail) {
        this.contactUsPage.querySelector("[data-confirmEmailError]").innerHTML =
          "Sorry, email address you entered does not match";
        this.contactUsPage
          .querySelector("[data-submitBtn]")
          .classList.add("disabled");
      } else {
        this.contactUsPage.querySelector("[data-confirmEmailError]").innerHTML =
          "";
        if (
          this.subjectField.value.length != 0 &&
          this.messageField.value.length != 0
        ) {
          this.contactUsPage
            .querySelector("[data-submitBtn]")
            .classList.remove("disabled");
        }
      }
    } else {
      this.contactUsPage.querySelector("[data-confirmEmailError]").innerHTML =
        "";
      if (
        this.subjectField.value.length != 0 &&
        this.messageField.value.length != 0
      ) {
        this.contactUsPage
          .querySelector("[data-submitBtn]")
          .classList.remove("disabled");
      }
    }
  }
  checkSubjectFieldCount(event) {
    let charLength = event.currentTarget.value.replace(/\s/g, "").length;
    if (charLength > 200) {
      this.contactUsPage.querySelector("[data-subjectError]").innerHTML =
        "Sorry, a maximum of 200 characters is allowed";
      this.contactUsPage
        .querySelector("[data-subjectError]")
        .classList.add("text-danger");
      this.contactUsPage
        .querySelector("[data-submitBtn]")
        .classList.add("disabled");
    } else {
      this.contactUsPage.querySelector(
        "[data-subjectError]"
      ).innerHTML = `${charLength} of 200 max characters`;
      this.contactUsPage
        .querySelector("[data-subjectError]")
        .classList.remove("text-danger");
      this.contactUsPage
        .querySelector("[data-submitBtn]")
        .classList.remove("disabled");
      if (charLength == 0 || this.messageField.value.length == 0) {
        this.contactUsPage
          .querySelector("[data-submitBtn]")
          .classList.add("disabled");
      }
    }
  }
  checkMessageFieldCount(event) {
    let charLength = event.currentTarget.value.replace(/\s/g, "").length;
    if (charLength > 1000) {
      this.contactUsPage.querySelector("[data-messageError]").innerHTML =
        "Sorry, a maximum of 1000 characters is allowed";
      this.contactUsPage
        .querySelector("[data-messageError]")
        .classList.add("text-danger");
      this.contactUsPage
        .querySelector("[data-submitBtn]")
        .classList.add("disabled");
    } else {
      this.contactUsPage.querySelector(
        "[data-messageError]"
      ).innerHTML = `${charLength} of 1000 max characters`;
      this.contactUsPage
        .querySelector("[data-messageError]")
        .classList.remove("text-danger");
      this.contactUsPage
        .querySelector("[data-submitBtn]")
        .classList.remove("disabled");
      if (charLength == 0 || this.subjectField.value.length == 0) {
        this.contactUsPage
          .querySelector("[data-submitBtn]")
          .classList.add("disabled");
      }
    }
  }
}

typeof customJS !== "undefined" && new customJS();


let quantityBtns = document.querySelectorAll('.mm_flavor_banner1_content_quantity button');
  quantityBtns.forEach((quantityBtn) => {
    quantityBtn.addEventListener('click', () => {
      changeQuantity(quantityBtn);
    });
  });
  
  function changeQuantity(btn) {
    let wrapper = btn.closest('.mm_flavor_banner1_content_btns');
    let wrapperInput = wrapper.querySelector('.input');
    let btnQuantity = wrapper.querySelector('button[data-quantity]');
    let prevValue = Number(wrapperInput.textContent);
    if(btn.classList.contains('plus')){
      wrapperInput.textContent = `${prevValue + 1} `;
      btnQuantity.setAttribute('data-quantity',`${prevValue + 1}`);
    }else{
      if(prevValue > 1)
      wrapperInput.textContent = `${prevValue - 1}`;
      btnQuantity.setAttribute('data-quantity',`${prevValue - 1}`);
    }
  }


let addToCartBtn = document.querySelectorAll('button[data-productId]');
  addToCartBtn.forEach((btn)=>{
    btn.addEventListener('click',(event)=>{
      let productId = btn.getAttribute('data-productId');
      let productQuantity = btn.getAttribute('data-quantity');
      console.log(productId);
      let formData = {
       'items': [{
        'id': productId,
        'quantity': productQuantity
        }]
      };
      
      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      })
      .then(response => {
        return response.json();
      })
      .catch((error) => {
        console.error('Error:', error);
      });

    })
  })


/*------- Insert Stack Builder to beginning of Stack & Save page -------*/

document.addEventListener("DOMContentLoaded", function() {
    // Check if the current URL path is exactly "/collections/stack-save"
    if (window.location.pathname === "/collections/stack-save") {
        var newElement = document.createElement("div");
        newElement.className = "col-6 col-md-4 d-flex align-items-stretch justify-content-around variantProductGrid";
        newElement.setAttribute("data-loop-index", "0");
        newElement.innerHTML = `


    <div class="product-card product-card-2024 pb-2 stack-save stack-builder stack-save" data-product-grid="" data-title="Stack Builder" data-price="00.00" data-position="1">
        <a href="/pages/stack-builder">
            <div class="product-image py-5 py-md-8">


                <img src="//nutrex.com/cdn/shop/files/BYO-Stack-1.png?v=1722285835&amp;width=350" srcset="//nutrex.com/cdn/shop/files/BYO-Stack-1.png?v=1722285835&amp;width=700 2x" width="240" height="240" alt="Nutrex Stack Builder">

                <div class="product-shadow"></div>

            </div>
        </a>

        <div class="product-details flex-grow-0 flex-md-grow-1 pb-1 pt-3 pt-md-2 px-2 px-md-3">

            <div class="row">
                <div class="col-12 col-md-8 pe-0 pe-md-1">
                    <h4 class="product-title">       
                        Build-Your-Own Stack                   
                    </h4>
                </div>
                <div class="d-none d-md-block col-md-4 ps-1">
                    <p class="product-price">

                    </p>

                </div>
            </div>
            <!--row-->
            <div class="row">
                <div class="col-12 product-subhead">

                    Choose the products that you want and <strong>Save Up To 35%</strong>

                </div>
            </div>
            <!--row-->

            <div class="row">
                <div class="col-12 d-flex align-items-center">

                </div>
            </div>

        </div>
        <!--product-details-->

        <div class="row d-md-none flex-grow-1 ps-4">

            <p class="product-price mobile ps-1 mb-1">
            </p>

        </div>


        <div class="row mx-0">

            <div class="col-12 mx-0 px-0 d-flex align-items-center">
                <a href="/pages/stack-builder" class="d-flex mx-2 mx-md-3 w-100 byos-link">
                    <button class="btn btn-sm p-0 flex-grow-1 add-to-cart btn-outline-secondary" type="submit" name="add" aria-label="Build Your Stack">
                        <span class="add-text text-uppercase">Start Building</span>
                        <span class="spinner"></span>
                    </button>
                </a>
            </div>
        </div>


        <div class="product-extra-info px-0 py-1">

        </div>

    </div>

        `;

        var container = document.querySelector("div.product-grid-row#template-collection-stack-save");
        container.insertBefore(newElement, container.firstChild);
    }
});